import React from "react";
import { Plan, PlanDetailsSection } from "../../../@types";
import {
  PlanDetailSection,
  DrugPlanStarRatings,
  HealthPlanStarRatings,
  PlanOverallStarRating,
} from "../../../components";
import { useTranslate, isMaPlanType, hideStarRatings } from "../../../helpers";
import { useFlags } from "launchdarkly-react-client-sdk";

const StarRatings: React.FunctionComponent<{ plan: Plan }> = ({ plan }) => {
  const { feEnableStarRatings, mctCurrentPlanYear } = useFlags();
  const t = useTranslate();

  return (
    <PlanDetailSection
      id={PlanDetailsSection.STAR_RATINGS}
      title={t("plan_stars.medicare.star_ratings")}
    >
      <PlanOverallStarRating
        starRating={plan.overall_star_rating}
        highPerforming={plan.high_performing}
        lowPerforming={plan.low_performing}
        planYear={plan.contract_year}
      />

      {!hideStarRatings(plan.contract_year, {
        feEnableStarRatings,
        mctCurrentPlanYear,
      }) && (
        <>
          <HealthPlanStarRatings plan={plan} />

          {!isMaPlanType(plan.plan_type) && <DrugPlanStarRatings plan={plan} />}
        </>
      )}
    </PlanDetailSection>
  );
};

export default StarRatings;
